module.exports = __webpack_public_path__ + "img/mcluster_product_3.89eb882a.jpg";